var quizOpen = false;
var quizCount = 0;

function quizShow() {
  document.getElementById("quiz-wrapper").style.display = "block";
  document.getElementById("quiz-wrapper").style.position = "fixed";
  document.getElementById("quiz-wrapper").style.zIndex = "9999999";
  document.getElementById("quiz-wrapper").style.overflow = "auto";
  document.getElementById("quiz-wrapper").style.height = "100%";
  document.getElementById("quiz-wrapper").style.width = "100vw";
  //$('.answers').css("padding-bottom","100%");
  //$('.freegift_answers').css("padding-bottom","100%");
  $("#question_email").css("padding-bottom", "100%");
  $(".next_button_background").css("z-index", "9999999");
  $(".bottombar-wrapper").css("position", "absolute");
  $("body").css("overflow", "hidden");
  $("body").css("position", "fixed");

  //Run session storage memory function here to get old answers
  var quizAnswers = JSON.parse(sessionStorage.getItem("answers"));
  if (quizAnswers) {
    for (i = 0; i < quizAnswers.length; i++) {
      document
        .getElementById(quizAnswers[i])
        .classList.toggle("answer_selected");
      document.getElementById(
        quizAnswers[i]
      ).parentElement.nextElementSibling.children[0].disabled = false;
    }
    //replaces free gift in timer box if you're on a different question
    if (quizAnswers[0] == "choice_freeexfoliator") {
      document.getElementById("timer_image").src =
        "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/freegift_exfoliator.jpg?v=1631559286";
    } else if (quizAnswers[0] == "choice_freemini") {
      document.getElementById("timer_image").src =
        "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/2wipessmall.png?v=1657153864";
    } else if (quizAnswers[0] == "choice_freebag") {
      document.getElementById("timer_image").src =
        "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/bag.jpg?v=1658779317";
    } else {
      document.getElementById("timer_image").src =
        "https://cdn.shopify.com/s/files/1/0335/1622/4645/t/111/assets/freegift_default_200x.png?v=6815870730005612561";
    }
  }

  if (replaceFaceWipes == true) {
    document.getElementById("choice_freemist").click();
    console.log("clicked");
  }

  //Sets back to current question
  var currentQ = sessionStorage.getItem("currentQ");
  if (currentQ) {
    if (currentQ != "question_freegift") {
      document.getElementById("question_freegift").classList.add("inactive");
      document.getElementById(currentQ).classList.remove("inactive");
    }
  } else {
    sessionStorage.setItem("currentQ", "question_freegift");
  }
  addFutureQuestions();
  setTimeout(function () {
    quizOpen = true;
    return quizOpen;
  }, 100);
  window.scrollTo(0, 0);

  // send quiz events
  if (quizCount == 0) {
    startTimerQ();
    gtag("event", "start_quiz", { start_quiz: "start_quiz" });
    window._conv_q = window._conv_q || [];
    _conv_q.push(["triggerConversion", "100317771"]);
  }
  quizCount = 1;
}

function quizHide() {
  $(".quiz-wrapper").css("display", "none");
  $("body").css("position", "");
  $("body").css("overflow", "auto");
  $(".bottombar-wrapper").css("position", "sticky");
  sessionStorage.setItem("currentQ", "");
  quizOpen = false;
  return quizOpen;
}

const targetNode = document.getElementById("offcanvas-cart-drawer");
const observerOptions = {
  childList: true,
  attributes: true,
  // Omit (or set to false) to observe only changes to the parent node
  subtree: false,
};

const observer = new MutationObserver(callback);
observer.observe(targetNode, observerOptions);

function callback(mutationList, observer) {
  mutationList.forEach((mutation) => {
    switch (mutation.type) {
      case "childList":
        cartUpsell();
        $("li.39709236887685").insertAfter($("li.CartDrawerItem").last());
        break;
      case "attributes":
        cartUpsell();
        $("li.39709236887685").insertAfter($("li.CartDrawerItem").last());
        break;
    }
  });
}

// //Loads to function for cart upsell recommendation
// const open = window.XMLHttpRequest.prototype.open;

// function openReplacement() {
//   this.addEventListener("load", function () {
//     if (
//       [
//         "/cart/add.js"
//       ].includes(this._url)
//     ) {
//       cartExfoliator(this.response);
//     }
//   });
//   return open.apply(this, arguments);
// }

// window.XMLHttpRequest.prototype.open = openReplacement;

// function cartExfoliator(cartJson) {
//   var item = JSON.parse(cartJson);
//   if (item.quantity == 1 && item.id != 39709236887685) {
//     /*ttq.track('AddToCart', {
//       content_type: 'product',
//       content_id: item.sku
//     });*/
// 	  //snaptr('track', 'ADD_CART');
//      //pintrk('track', 'addtocart', {currency: 'USD'});
//     //Convert ATC
//     window._conv_q = window._conv_q || [];
//     _conv_q.push(["triggerConversion", "100321605"]);
//   }
//   if (item.variant_title == 'Fresh Powder') {
//     window._conv_q = window._conv_q || [];
//     _conv_q.push(["triggerConversion", "100320289"]);
//   }

//   if(item.variant_id == 40203921129605){
//     //FACE PRIMER ATC EVENT
//     window._conv_q = window._conv_q || [];
//     _conv_q.push(["triggerConversion", "100321471"]);
//   }

//   //this auto changes holiday one pack to the 3 pack
//   if (item.variant_id == 40007449510021) {
//       cartUpdates = {
//         'updates': {
//           40007449510021: 0,
//           40007449870469: 1
//         }
//       };
//       jQuery.ajax({
//         type: 'POST',
//         url: '/cart/update.js',
//         data: cartUpdates,
//         dataType: 'json',
//         success: function() {
//           fetch('/?section_id=cart-drawer')
//           .then(response => response.text())
//           .then(data => document.getElementById('offcanvas-cart-drawer').innerHTML = data);
//         }
//       });
//   }

//   //update item properties on product-form submit
//   //propertyValue = document.getElementById('property_value').value;
//   //jQuery.post('/cart/change.js', { properties: { item_total: propertyValue}, id: item.items[0].key })

//   //This code adds the exfoliator to cart (GWP)
//   /*if (item.product_id == 5115172159621 || item.product_id == 6657190199429 || item.product_id == 5110023749765 || item.product_id == 5115170979973 || item.product_id == 5110006022277 || item.product_id == 5110018932869 || item.product_id == 6591209963653 || item.product_id == 6607242559621 || item.product_id == 6607242526853 || item.product_id == 6648686248069 || item.product_id == 6657195671685 || item.product_id == 6648666095749 || item.product_id == 6648688115845 || item.product_id == 6648687624325) {
//     cartUpdates = {
//       "id": 39709236887685,
//       "quantity": 1,
//     };
//     jQuery.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: cartUpdates,
//       dataType: 'json',
//       success: function() {
//         fetch('/?section_id=cart-drawer')
//           .then(response => response.text())
//           .then(data => document.getElementById('offcanvas-cart-drawer').innerHTML = data);
//       }
//     });
//   }*/
// }

$(document).ready(function () {
  if ($(".ProductRadioButtons-itemLabel.Original")[0]) {
    $(".ProductForm-variant-title.Original").replaceWith(
      '<div class="ProductForm-variant-title Original">Eucalyptus</div>'
    );
  }
  if ($(".ProductRadioButtons-itemLabel.Coconut")[0]) {
    // $(".ProductForm-variant-title.Coconut").replaceWith(
    //   '<div class="ProductForm-variant-title Coconut">Coconut<br/>Vanilla</div>'
    // );
    $(".ProductForm-variant-title.Coconut").replaceWith(
      '<div class="ProductForm-variant-title Coconut">Coconut<br/>Vanilla<br/><span style="color:#DF0334">Out Of Stock</span></div>'
    );
    document.getElementsByClassName(
      "ProductRadioButtons-itemLabel Coconut"
    )[0].previousElementSibling.disabled = true;
  }
  if ($(".ProductRadioButtons-itemLabel.Vanilla")[0]) {
    //$('.ProductForm-variant-title.Vanilla').replaceWith('<div class="ProductForm-variant-title Vanilla">Warm<br/>Vanilla</div>');
    //$('.ProductForm-variant-title.Vanilla').replaceWith('<div class="ProductForm-variant-title Vanilla">Warm<br/>Vanilla<br/><span style="color:#DF0334">Out Of Stock</span></div>');
    //document.getElementsByClassName('ProductRadioButtons-itemLabel Vanilla')[0].previousElementSibling.disabled = true;
  }
  if ($(".ProductRadioButtons-itemLabel.Fresh.Powder")[0]) {
    // $(".ProductForm-variant-title.Fresh.Powder").replaceWith(
    //   '<div class="ProductForm-variant-title Fresh Powder">Fresh<br/>Powder<br/><span style="line-height:14px;">(FAVORITE)</span></div>'
    // );
    $('.ProductForm-variant-title.Fresh').replaceWith('<div class="ProductForm-variant-title Fresh">Fresh Powder<br/><span style="color:#DF0334">Out Of Stock</span></div>');
    document.getElementsByClassName('ProductRadioButtons-itemLabel Fresh')[0].previousElementSibling.disabled = true;
  }
  if ($(".ProductRadioButtons-itemLabel.Bergamot")[0]) {
    // $(".ProductForm-variant-title.Bergamot").replaceWith(
    //   '<div class="ProductForm-variant-title Bergamot">Bergamot & Oud<br/><span style="line-height:14px;">(NEW)</span></div>'
    // );
    $(".ProductForm-variant-title.Bergamot").replaceWith(
      '<div class="ProductForm-variant-title Bergamot">Bergamot <br>& Oud<br/><span style="color:#DF0334">Out Of Stock</span></div>'
    );
    document.getElementsByClassName(
      "ProductRadioButtons-itemLabel Bergamot"
    )[0].previousElementSibling.disabled = true;
  }
  if ($(".ProductRadioButtons-itemLabel.Clean")[0]) {
    // $(".ProductForm-variant-title.Clean").replaceWith(
    //   '<div class="ProductForm-variant-title Bergamot">Clean Sport<br/><span style="line-height:14px;">(NEW)</span></div>'
    // );
    $('.ProductForm-variant-title.Clean').replaceWith('<div class="ProductForm-variant-title Clean">Clean Sport<br/><span style="color:#DF0334">Out Of Stock</span></div>');
    document.getElementsByClassName('ProductRadioButtons-itemLabel Clean')[0].previousElementSibling.disabled = true;
  }
  /*if($('.ProductRadioButtons-itemLabel.Fresh.Linen')[0]){
     $('.ProductForm-variant-title.Fresh.Linen').replaceWith('<div class="ProductForm-variant-title Fresh">Fresh Linen<br/><span style="color:#DF0334">Out Of Stock</span></div>');
    document.getElementsByClassName('ProductRadioButtons-itemLabel Fresh')[0].previousElementSibling.disabled = true;
  }*/

  if ($(".ProductRadioButtons-itemLabel.Cucumber.Spa")[0]) {
    $(".ProductForm-variant-title.Cucumber.Spa").replaceWith(
      '<div class="ProductForm-variant-title Cucumber Spa">Cucumber Spa<br/><span style="line-height:14px;">(NEW)</span></div>'
    );
    $(".ProductRadioButtons-itemLabel-value.Cucumber.Spa").css({
      "background-color": "#00965F",
    });
    $(".ProductRadioButtons-itemLabel.Cucumber.Spa").css({
      border: "2px solid #00965F",
    });

    // $('.ProductForm-variant-title.Cucumber.Spa').replaceWith('<div class="ProductForm-variant-title Cucumber">Cucumber<br/>Spa<br/><span style="color:#DF0334">Out Of Stock</span></div>');
    // document.getElementsByClassName('ProductRadioButtons-itemLabel Spa')[0].previousElementSibling.disabled = true;
  }

  if ($(".ProductRadioButtons-itemLabel.Sandalwood")[0]) {
    // $(".ProductForm-variant-title.Sandalwood").replaceWith(
    //   '<div class="ProductForm-variant-title Sandalwood">Sandalwood<br/></div>'
    // );
    $(".ProductForm-variant-title.Sandalwood").replaceWith(
      '<div class="ProductForm-variant-title Sandalwood">Sandalwood<br/><span style="color:#DF0334">Out Of Stock</span></div>'
    );
    document.getElementsByClassName(
      "ProductRadioButtons-itemLabel Sandalwood"
    )[0].previousElementSibling.disabled = true;
  }

  if ($(".ProductRadioButtons-itemLabel.Lavender")[0]) {
    $(".ProductRadioButtons-itemLabel-value.Lavender").css({
      "background-color": "#8D7ACA",
    });
    $(".ProductRadioButtons-itemLabel.Lavender").css({
      border: "2px solid #8D7ACA",
    });
    // $(".ProductForm-variant-title.Lavender").replaceWith(
    //   '<div class="ProductForm-variant-title Lavender">Lavender Citrus<br/></div>'
    // );
    //$(".ProductForm-variant-title.Lavender").replaceWith(
    //'<div class="ProductForm-variant-title .Lavender">Lavender Citrus<br/><span style="color:#DF0334">Out Of Stock</span></div>'
    //);
    //document.getElementsByClassName(
    // "ProductRadioButtons-itemLabel Lavender"
    //)[0].previousElementSibling.disabled = true;
  }
  if ($(".ProductRadioButtons-itemLabel.Fragrance")[0]) {
    $(".ProductForm-variant-title.Fragrance").replaceWith(
      '<div class="ProductForm-variant-title Fragrance">Fragrance<br/>Free</div>'
    );
    // $('.ProductForm-variant-title.Fragrance').replaceWith('<div class="ProductForm-variant-title Fragrance">Fragrance Free<br/><span style="color:#DF0334">Out Of Stock</span></div>');
    // document.getElementsByClassName('ProductRadioButtons-itemLabel Fragrance')[0].previousElementSibling.disabled = true;
  }

  if ($(".ProductRadioButtons-itemLabel.Mountain")[0]) {
    $(".ProductForm-variant-title.Mountain").replaceWith(
      '<div class="ProductForm-variant-title Mountain">Mountain<br/>Breeze</div>'
    );
    // $(".ProductForm-variant-title.Mountain").replaceWith(
    //   '<div class="ProductForm-variant-title Mountain">Mountain<br/>Breeze<br/><span style="color:#DF0334">Out Of Stock</span></div>'
    // );
    // document.getElementsByClassName(
    //   "ProductRadioButtons-itemLabel Mountain"
    // )[0].previousElementSibling.disabled = true;
  }

  /*if($('.ProductRadioButtons-itemLabel.Deep')[0]){
    document.getElementsByClassName('js-product-options')[0].style.display = "none"; 
  }*/
  if ($(".ProductRadioButtons-itemLabel.Rose")[0]) {
    // $('.ProductForm-variant-title.Rose').replaceWith('<div class="ProductForm-variant-title Rose">Rose Water<br/><span style="color:#DF0334">Out Of Stock</span></div>');
    // document.getElementsByClassName('ProductRadioButtons-itemLabel Rose')[0].previousElementSibling.disabled = true;
  }

  if ($(".ProductRadioButtons-itemLabel.Mountain")[0]) {
    //document.getElementsByClassName('ProductRadioButtons-item')[2].style.display = "none";
    //document.getElementsByClassName('ProductRadioButtons-item')[3].style.display = "none";
    //document.getElementsByClassName('ProductRadioButtons-item')[4].style.display = "none";
    //document.getElementsByClassName('ProductRadioButtons-item')[5].style.display = "none";
    //document.getElementsByClassName('ProductRadioButtons-item')[7].style.display = "none";
    // document.getElementsByClassName(
    //   "ProductRadioButtons-item"
    // )[8].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[9].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[10].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[11].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[12].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[13].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[14].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[15].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[16].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[17].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[18].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[19].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[20].style.display = "none";
    document.getElementsByClassName(
      "ProductRadioButtons-item"
    )[21].style.display = "none";
  }

  if ($(".ProductRadioButtons-itemLabel.White")[0]) {
    //hand
    //document.getElementsByClassName('ProductRadioButtons-item')[1].style.display = "none";
    //document.getElementsByClassName('ProductRadioButtons-item')[3].style.display = "none";
    //for (var q=0;q<document.getElementsByClassName('ProductRadioButtons-item').length;q++){
    //document.getElementsByClassName('ProductRadioButtons-item')[q].style.flex = "1 0 15%";
    //}
    $(".ProductForm-variant-title.Warm").replaceWith(
      '<div class="ProductForm-variant-title Warm">Warm<br/>Vanilla</div>'
    );
    // document.getElementsByClassName('ProductRadioButtons-itemLabel Warm')[0].previousElementSibling.disabled = true;
  }

  //swaps default to Lav Cit
  /*if($('.ProductRadioButtons-itemLabel.Lavender')[0]){
      if (lavCitSlot === true) {
        $('.ProductForm-variant-title.Fresh.Powder').replaceWith('<div class="ProductForm-variant-title Fresh">Fresh<br/>Powder</div>');
        $('.ProductForm-variant-title.Lavender').replaceWith('<div class="ProductForm-variant-title Lavender">Lavender<br/>Citrus<br/><span style="line-height:14px;">(FAVORITE)</span></div>');
        var items = document.getElementsByClassName('ProductRadioButtons-item')[0];
        items.parentNode.insertBefore(document.getElementsByClassName('ProductRadioButtons-item')[2], items);
        $('.ProductRadioButtons-item')[0].firstElementChild.click();
      }
    }*/

  // swaps default to CL
  //#changeStickOrder
  //===================================================
  // if ($(".ProductRadioButtons-itemLabel.Clean")[0]) {
  //   $(".ProductForm-variant-title.Fresh.Powder").replaceWith(
  //     '<div class="ProductForm-variant-title Fresh">Fresh<br/>Powder</div>'
  //   );
  //   $(".ProductForm-variant-title.Clean").replaceWith(
  //     '<div class="ProductForm-variant-title Clean">Clean Sport<br/><span style="line-height:14px;">(FAVORITE)</span></div>'
  //   );
  //   var firstSlot = document.getElementsByClassName("ProductRadioButtons-item")[0];
  //   firstSlot.parentNode.insertBefore(
  //     document.getElementsByClassName("ProductRadioButtons-item")[5],
  //     firstSlot
  //   );

  //   // put Fresh Powder item in 5 index
  //   var freshPowder = document.querySelector(".ProductRadioButtons-itemLabel.Fresh").closest(".ProductRadioButtons-item");
  //   var freshPowderParent = freshPowder.parentNode;
  //   freshPowderParent.insertBefore(freshPowder, freshPowderParent.children[5] || null);

  //   $(".ProductRadioButtons-item")[0].firstElementChild.click();
  // } 

  // swaps default to CL
  //===================================================
  // if ($(".ProductRadioButtons-itemLabel.Clean")[0]) {
  //   if (cleanSportFirstSlot === true) {
  //     console.log("cleanSportFirstSlotIsTrue");
  //     $(".ProductForm-variant-title.Fresh.Powder").replaceWith(
  //       '<div class="ProductForm-variant-title Fresh">Fresh<br/>Powder</div>'
  //     );
  //     $(".ProductForm-variant-title.Clean").replaceWith(
  //       '<div class="ProductForm-variant-title Clean">Clean<br/>Sport<br/><span style="line-height:14px;">(FAVORITE)</span></div>'
  //     );
  //     var items = document.getElementsByClassName(
  //       "ProductRadioButtons-item"
  //     )[0];
  //     items.parentNode.insertBefore(
  //       document.getElementsByClassName("ProductRadioButtons-item")[5],
  //       items
  //     );
  //     $(".ProductRadioButtons-item")[0].firstElementChild.click();
  //   }
  // }

  //   if ($('.ProductForm-variant-title.Lavender').length) {
  //     freshPowderSlot = true;
  //     lavCitSlot = true;
  // }

  // FRESH POWDER NOT #1 SLOT TEST
  // $(document).ready(function() {
  //  if (freshPowderSlot === true) {
  //     if (lavCitSlot === true) {
  //       // var items = document.getElementsByClassName('ProductRadioButtons-groupwrapper')[0];
  //       // items.parentNode.insertBefore(document.getElementsByClassName('ProductRadioButtons-item')[1], items);
  //       // $('.ProductRadioButtons-item')[0].firstElementChild.click();

  //       let pdpItemsWrapper = document.querySelector(".ProductRadioButtons-groupwrapper");

  //       if (!pdpItemsWrapper) return;

  //       // Helper function to move an element to a specific position
  //       const pdpMoveElement = (id, position) => {
  //           let pdpElement = pdpItemsWrapper.children[id];
  //           if (pdpElement) {
  //               // Remove the element from its current position
  //               pdpItemsWrapper.removeChild(pdpElement);
  //               // Insert the element at the desired position
  //               let pdpReferenceNode = pdpItemsWrapper.children[position];
  //               pdpItemsWrapper.insertBefore(pdpElement, pdpReferenceNode );
  //           } else {
  //               console.warn(`Element with id ${id} not found.`);
  //           }
  //       };

  //       // Reorder elements
  //       pdpMoveElement(1, 0); // Move LC to position 0
  //       pdpMoveElement(4, 1); // Move CV to posistion 1
  //       pdpMoveElement(6, 4); // Move CV to posistion 1
  //       pdpMoveElement(2, 4); // Move FP to posistion 5

  //       $('.ProductForm-variant-title.Fresh').replaceWith('<div class="ProductForm-variant-title Fresh">Fresh<br/>Powder</div>');
  //       $('.ProductForm-variant-title.Lavender').replaceWith('<div class="ProductForm-variant-title Lavender">Lavender Citrus<br/><span style="line-height:14px;">(FAVORITE)</span></div>');
  //       $('.ProductRadioButtons-item')[0].firstElementChild.click();
  //     }

  //   }
  // });

  //this checks the child input when radio item is clicked - fixes issue of scent not changing when user clicks parent
  $(".ProductRadioButtons-item").click(function () {
    if (event.target.tagName === "INPUT") {
      return;
    }
    var scentFixerIndex = $(this).index();
    //console.log(scentFixerIndex)
    if (scentFixerIndex != 8 && scentFixerIndex != 10) {
      document
        .getElementsByClassName("ProductRadioButtons-item")
      [scentFixerIndex].childNodes[1].click();
    }
  });

  //Pop-up stuff
  $(".js-additempopupclose").click(function () {
    $("#additem-popup").fadeOut("slow");
    var modal_overlay = document.querySelector(".modal_overlay");
    if (modal_overlay) {
      modal_overlay.classList.remove("active");
    }
  });
  $(".modal_overlay").click(function () {
    $("#progress-popup").fadeOut("slow");
    $("#additem-popup").fadeOut("slow");
    var modal_overlay = document.querySelector(".modal_overlay");
    if (modal_overlay) {
      modal_overlay.classList.remove("active");
    }
  });
  //Subscription block
  $(".rc_block rc_block__type rc_block__type__autodeliver").click(function () {
    var rc_block = document.querySelector(
      ".rc_block rc_block__type rc_block__type__autodeliver"
    );
    rc_block.classList.add("rc_block__type--active");
    $(".rc_block rc_block__type rc_block__type__onetime").removeClass(
      "rc_block__type--active"
    );
  });
  //TikTok Initiate checkout
  /*$('.Cart-checkoutButton').click(function() {
      ttq.track('InitiateCheckout');
    })*/
});

//Subscription info modal JS
function subinfomodal() {
  document.getElementById("sub-info-modal").style.display = "block";
}
function closesubinfomodal() {
  document.getElementById("sub-info-modal").style.display = "none";
}
//Donate info modal JS
function donateinfomodal() {
  document.getElementById("donate-info-modal").style.display = "block";
}
function closedonateinfomodal() {
  document.getElementById("donate-info-modal").style.display = "none";
}

var jdgmImg = document.getElementsByClassName(
  "jdgm-carousel-item__product-image"
);
for (var i = 0; i < jdgmImg.length; i++) {
  if (jdgmImg[i].getAttribute("src")) {
    jdgmImg[i].classList.add("lazyload");
    jdgmImg[i].setAttribute("data-src", jdgmImg[i].getAttribute("src"));
    jdgmImg[i].removeAttribute("src");
    jdgmImg[i].removeAttribute("srcset");
  }
}

//Home Animation
$(document).ready(function () {
  const el = document.querySelectorAll(".animate-on-scroll");
  const headerObserver = new window.IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate");
          return;
        }
      });
    },
    {
      root: null,
      threshold: 0, // set offset 0.1 means trigger if atleast 10% of element in viewport
    }
  );
  for (i = 0; i < el.length; i++) {
    headerObserver.observe(el[i]);
  }
});

//PLP Animation
$(document).ready(function () {
  const el = document.querySelectorAll(".plp-animate-on-scroll");
  const headerObserver = new window.IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate2");
          return;
        }
      });
    },
    {
      root: null,
      threshold: 0, // set offset 0.1 means trigger if atleast 10% of element in viewport
    }
  );
  for (i = 0; i < el.length; i++) {
    headerObserver.observe(el[i]);
  }
});

/* const el = document.querySelectorAll('.lazyloadBG')
const headerObserver = new window.IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.remove('lazyloadBG')
      entry.target.style.backgroundImage = 'url("'+entry.target.dataset.bgset+'")'
      return
    }
  })
  console.log('LEAVE');
}, {
  root: null,
  threshold: 0, // set offset 0.1 means trigger if atleast 10% of element in viewport
})
for(i=0;i<el.length;i++){
  headerObserver.observe(el[i]);
} */

//refresh cart drawer when back button clicked
window.onpopstate = function (event) {
  console.log("Back button was clicked.");
  fetch('/?section_id=site-discount-bar-site-header')
    .then((response) => response.text())
    .then((data) => {
      const progressContainer = document.querySelector("[data-site-discount-bar-type='site-header']");
      if (!progressContainer) return;
      if (window.CartProgress && typeof window.CartProgress.destroyWithin === "function") {
        window.CartProgress.destroyWithin(progressContainer);
      }
      progressContainer.innerHTML = data;
      if (window.CartProgress && typeof window.CartProgress.hydrate === "function") {
        window.CartProgress.hydrate(progressContainer);
      }
    });
};
